__turbopack_context__.v({
  "CarouselHeroCard": "CarouselHeroCard-module__yV0waa__CarouselHeroCard",
});
